import React from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es difícil de leer?',
    a: 'No, hemos usado letra grande y un lenguaje sencillo y respetuoso.'
  }, {
    q: '¿Necesito tecnología?',
    a: 'Solo para descargar el PDF. Una vez impreso, es 100% analógico.'
  }, {
    q: '¿Funciona si tengo más de 80 años?',
    a: 'Sí, la neuroplasticidad no tiene fecha de vencimiento.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Directamente a su correo electrónico tras la compra.'
  }, {
    q: '¿Puedo compartirlo con mis amigas?',
    a: 'Está diseñado para uso personal, pero le encantará comentar los ejercicios con ellas.'
  }];
  return <section className="bg-amber-50 py-16 md:py-24 px-4" data-id="element-57">
      <div className="max-w-3xl mx-auto" data-id="element-58">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-900 mb-10 text-center" data-id="element-59">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-6" data-id="element-60">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-amber-100" data-id="element-61">
              <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-62">{faq.q}</h3>
              <p className="text-lg text-stone-700" data-id="element-63">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}